"use strict";
import { BNB_LOGO, CELO_LOGO } from "ui/src/assets";
import {
  BTCB_BSC_TESTNET,
  CAKE_BSC_TESTNET,
  ETH_BSC_TESTNET,
  TOPAZ_BSC_MAINNET,
  TOPAZ_BSC_TESTNET,
  USDC_BSC_MAINNET,
  USDC_BSC_TESTNET,
  USDT_BSC_MAINNET,
  USDT_BSC_TESTNET,
  WBNB_BSC_MAINNET,
  WBNB_BSC_TESTNET,
  isCelo,
  nativeOnChain
} from "constants/topazTokenList";
import { ProtectionResult } from "data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { getChainInfo } from "features/chains/chainInfo";
import { UniverseChainId } from "features/chains/types";
import { TokenList } from "features/dataApi/types";
import { buildCurrencyInfo } from "features/dataApi/utils";
import { currencyId } from "utils/uniswapCurrencyId";
import { getTokenLogoUrl } from "constants/tokenLogos";
import { isSameAddress } from "utilities/src/addresses";
export const COMMON_BASES = {
  [UniverseChainId.Mainnet]: [
    nativeOnChain(UniverseChainId.Mainnet),
    WBNB_BSC_MAINNET,
    USDC_BSC_MAINNET,
    USDT_BSC_MAINNET,
    TOPAZ_BSC_MAINNET
  ].map(buildPartialCurrencyInfo),
  [UniverseChainId.Sepolia]: [
    nativeOnChain(UniverseChainId.Sepolia),
    WBNB_BSC_TESTNET,
    TOPAZ_BSC_TESTNET,
    USDC_BSC_TESTNET,
    USDT_BSC_TESTNET,
    ETH_BSC_TESTNET,
    BTCB_BSC_TESTNET,
    CAKE_BSC_TESTNET
  ].map(buildPartialCurrencyInfo)
};
const alwaysShowList = [USDC_BSC_MAINNET, USDC_BSC_TESTNET];
function getNativeLogoURI(chainId = UniverseChainId.Mainnet) {
  return getChainInfo(chainId).nativeCurrency.logo ?? BNB_LOGO;
}
function getTokenLogoURI(chainId, address) {
  const chainInfo = getChainInfo(chainId);
  const networkName = chainInfo?.assetRepoNetworkName;
  if (isCelo(chainId) && isSameAddress(address, nativeOnChain(chainId).wrapped.address)) {
    return CELO_LOGO;
  }
  if (chainId === UniverseChainId.Mainnet || chainId === UniverseChainId.Sepolia) {
    const tokenLogo = getTokenLogoUrl(address);
    if (tokenLogo) {
      return tokenLogo;
    }
  }
  return networkName ? `https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/${networkName}/assets/${address}/logo.png` : void 0;
}
export function buildPartialCurrencyInfo(commonBase) {
  const logoUrl = commonBase.isNative ? getNativeLogoURI(commonBase.chainId) : getTokenLogoURI(commonBase.chainId, commonBase.address);
  return buildCurrencyInfo({
    currency: commonBase,
    currencyId: currencyId(commonBase),
    logoUrl,
    safetyInfo: {
      protectionResult: ProtectionResult.Benign,
      tokenList: TokenList.Default
    },
    isSpam: false
  });
}
export function getTokenLogoTableItem(chainId, address, table) {
  if (isCelo(chainId) && isSameAddress(address, nativeOnChain(chainId).wrapped.address)) {
    return buildPartialCurrencyInfo(nativeOnChain(chainId).wrapped);
  }
  const networkName = getChainInfo(chainId).assetRepoNetworkName;
  if (!networkName) {
    return void 0;
  }
  return table[`${networkName.toUpperCase()}_${address.toLowerCase()}`];
}
export function getCommonBase(chainId, isNative, address) {
  if (!address || !chainId) {
    return void 0;
  }
  return COMMON_BASES[chainId]?.find(
    (base) => base.currency.isNative && isNative || base.currency.isToken && isSameAddress(base.currency.address, address)
  );
}
export function isAlwaysShowToken(token) {
  const candidate = token;
  return alwaysShowList.some((t) => t.address === candidate.address && t.chainId === candidate.chainId);
}
